export const textLVLP = {
    fr: {
        desc: [
            "Situé en plein coeur du quartier historique du Vieux-La Prairie, LeVIVO La Prairie offre une milieu de vie chaleureux et confortable. Le mandat de simdev débutait avec le pré-développement du terrain en démolissant le bâtiment existant et en gérant tout le volet conception et approbation auprès du ministère du Patrimoine et de la ville de La Prairie. La construction a débuté en Mars 2019 pour se terminer en Février 2020 avec une livraison complète du bâtiment",
        ],
    },
    en: {
        desc: [
            "Located in the heart of the historic district of Vieux-La Prairie, LeVIVO La Prairie offers a warm and comfortable living environment. Simdev's mandate began with the pre-development of the land, including the demolition of the existing building, and managing the entire design and approval process with the Ministry of Heritage and the City of La Prairie. Construction started in March 2019 and was completed in February 2020, with the building being fully delivered.",
        ]
    }

}